<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
      <v-layout class="fill-height" id="nav-background" tag="v-list" column>
        <v-list-tile class="d-flex justify-center logo-title">
          <!-- <v-img contain src="/img/hsp_256px_tag_white.svg" /> -->
          <router-link :to="homePath" @click.native="navigation && $emit('navigate', 0)">
            <img
              :src="require('@/assets/TastingIQlogotype-withHSP.svg')"
              class="drawer-logo"
              alt="TastingIQ by HSP Brands"
              />
          </router-link>
        </v-list-tile>
        <v-divider />
        <v-list-tile v-if="false">
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="purple"
          />
        </v-list-tile>
        <v-list-tile
          v-for="(link, i) in computedLinks"
          :key="i"
          :to="link.to"
          :active-class="color"
          :value="navigation ? link.tab === activeView : undefined"
          :tag="navigation ? 'button' : undefined"
          :type="navigation ? 'button' : undefined"
          avatar
          class="v-list-item"
          @click="navigation && $emit('navigate', link.tab)"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="link.text" />
        </v-list-tile>

        <v-spacer></v-spacer>

        <v-divider class="mt-2"></v-divider>

         <!-- Admin Panel Section -->
        <!-- Hide the admin panel because their minds can't comprehend it yet -->
        <div v-if="true===false">
          <transition name="fade">
            <div v-if="showAdminPanel" class="admin-panel pa-3">
              <v-card dark>
                <v-card-text>
                  <div class="text-center mb-3">
                    <span class="caption grey--text">Signed in as</span>
                    <div class="font-weight-medium">{{ username }}</div>
                  </div>
                  
                  <v-form ref="passwordForm" v-model="formValid" @submit.prevent="changePassword">
                    <v-text-field
                      v-model="oldPassword"
                      label="Current Password"
                      type="password"
                      :rules="[rules.required]"
                      dense
                      outlined
                    ></v-text-field>
                    
                    <v-text-field
                      v-model="newPassword"
                      label="New Password"
                      type="password"
                      :rules="[rules.required, rules.min]"
                      dense
                      outlined
                    ></v-text-field>
                    
                    <v-text-field
                      v-model="confirmPassword"
                      label="Confirm Password"
                      type="password"
                      :rules="[rules.required, passwordMatch]"
                      dense
                      outlined
                    ></v-text-field>
                    
                    <v-card
                      v-if="errorMessage"
                      color="error"
                      class="my-2 white--text"
                      id="errorMessage"
                    >
                      <v-card-text class="d-flex align-center">
                        <v-icon small left>mdi-alert-box</v-icon>
                        {{ errorMessage }}
                      </v-card-text>
                    </v-card>
                    
                    <v-btn 
                      block
                      color="primary"
                      :disabled="!formValid"
                      :loading="loading"
                      type="submit"
                      class="mt-2"
                    >
                      Change Password
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </div>
          </transition>

          <v-list-tile
            @click="toggleAdminPanel"
            avatar
            class="v-list-item admin-link mt-2"
          >
            <v-list-tile-action>
              <v-icon>mdi-cogs</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Account</v-list-tile-title>
            <v-list-tile-action>
              <v-icon>{{ showAdminPanel ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </div>

      </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { TokenService } from "../../services/storage.service";

export default {
  props: {
    navigation: { type: Array, default: null },
    activeView: { type: Number, default: 0 },
    homePath: { type: String, default: '/analytics' }
  },
  data: () => ({
    logo: "/img/salespros-logo.png",
    clientLinks: [
      {
        to: "/analytics",
        icon: "mdi-finance",
        text: "Analytics",
      },
      {
        to: "/events",
        icon: "mdi-account-search",
        text: "Event Details",
      },
      {
        to: "/schedule",
        icon: "mdi-calendar",
        text: "Schedule",
      },
      {
        to: "/media",
        icon: "mdi-rocket",
        text: "Digital Media",
      }

      //
      // REMOVE THESE COMMENTS TO ENABLE THE INSIGHTS VIEW
      //

      // ,
      // {
      //   to: "/insights",
      //   icon: "mdi-finance",
      //   text: "Insights",
      // }

    ],
    retailLinks: [
      {
        to: "/calendar",
        icon: "mdi-calendar-month",
        text: "Calendar",
      },
      {
        to: "/schedule",
        icon: "mdi-calendar",
        text: "Schedule",
      },
      {
        to: "/events",
        icon: "mdi-account-search",
        text: "Event Details",
      },
      {
        to: "/analytics",
        icon: "mdi-finance",
        text: "Analytics",
      }
    ],
    responsive: false,
    // Admin panel data
    showAdminPanel: false,
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    formValid: false,
    loading: false,
    errorMessage: "",
    rules: {
      required: v => !!v || "This field is required",
      min: v => (v && v.length >= 12) || "Password must be at least 12 characters"
    }
  }),

  computed: {

    ...mapState("app", ["image", "color"]),

    inputValue: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.setDrawer(val);
      },
    },

    username() {
      return TokenService.getUsername()
    },

    items() {
      return this.$t("Layout.View.items")
    },

    passwordMatch() {
      return () => this.newPassword === this.confirmPassword || "Passwords do not match"
    },

    computedLinks() {
      if (this.navigation) return this.navigation
      if (this.loginType !== 'retail') {
        const links = [...this.clientLinks]
        if (this.eventRequestEnabled === 1 || this.eventRequestEnabled === '1') {
          links.push({
            to: "/event-request",
            icon: "mdi-clipboard-text",
            text: "Event Request",
          })
        }
        return links
      }
      // Copy so the source array is never mutated across recomputes
      const links = [...this.retailLinks]
      // Insert the Item List drawer only when the retailer has it enabled
      if (this.itemListView === 1 || this.itemListView === '1') {
        links.splice(1, 0, {
          to: "/item-list",
          icon: "mdi-format-list-bulleted",
          text: "Item List",
        })
      }
      return links
    },

    loginType () {
      return this.$store.state.login_type
    },

    eventRequestEnabled () {
      const client = this.$store.state.client
      if (client && client.event_request != null) {
        return client.event_request
      }
      return 0
    },

    // Read reactively from the store so the drawer updates after set_retail
    // commits on the same page load; fall back to localStorage on reload
    itemListView () {
      const retail = this.$store.state.retail
      if (retail && retail.show_item_list != null) {
        return retail.show_item_list
      }
      return TokenService.getItemListView()
    },
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    toggleAdminPanel() {
      this.showAdminPanel = !this.showAdminPanel;
      // Reset form when closing
      if (!this.showAdminPanel) {
        this.resetForm()
      }
    },
    resetForm() {
      this.oldPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
      this.errorMessage = ""
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.reset()
      }
    },
    async changePassword() {
      if (!this.formValid) return
      
      this.loading = true
      this.errorMessage = ""
      
      try {

        const response = await this.$store.dispatch('updatePassword', {
          username: this.username,
          newPassword: this.newPassword,
          oldPassword: this.oldPassword
        })
        
        if (response.status === 'success') {
          alert("Password changed successfully")
          this.resetForm()
          this.showAdminPanel = false
        } else if (response.status === 'failure') {
          console.log(response)
          this.errorMessage = "Failed to change password. Please check your credentials."
        } else {
          this.errorMessage = "Unexpected response from server."
        }
      } catch (error) {
        // Error handling
        this.errorMessage = "Failed to change password. Please try again."
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  },
}
</script>

<style lang="scss">
  #app-drawer {
    button.v-list__tile {
      width: 100%;
      text-align: left;
    }

    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }

    .admin-link {
      margin-bottom: 16px;
    }

    .admin-panel {
      margin-bottom: 16px;
      
      .v-card {
        background-color: #5F5F5FAA;
      }
      
      .v-text-field {
        margin-top: 8px;
        margin-bottom: 8px;
      }
    }

    #errorMessage {
      background-color: #5F5F5F00 !important;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter, .fade-enter-from, .fade-leave-to {
      opacity: 0;
    }
  }

  .drawer-logo {
    display: block;
    width: 100%;
    height: auto;
    max-width: 500px;
    filter: brightness(0) invert(1);
  }

  .logo-title {
    height: auto;
    min-height: 0;
    margin-top: 80px;
    margin-bottom: 50px;
  }

</style>
